<template>
    <div class="flex flex-wrap">
        <!-- native modifier has been removed, please confirm whether the function has been affected  -->
        <InputCheckbox
            v-for="type in types"
            :key="type.id"
            :model-value="type.id === '0' ? !sanitizedValue.length : sanitizedValue"
            :value="type.id"
            :name="name"
            class="input text-sm mt-2 mb-3 w-1/2"
            @change="onChange($event)"
            @click="onClick($event, type)"
        >
            {{ type.name }}
            <span
                v-if="type.total !== null"
                class="ml-1"
            >
                ({{ type.total }})
            </span>
        </InputCheckbox>
    </div>
</template>

<script>
import { DOCUMENT_CONTENT_TYPE_VALUES } from '@/utils/documentUtils';
import { removeFromArray } from '@helpers/array';
import InputCheckbox from '@/components/InputCheckbox';

// convert to int to string as this input works with strings instead
const stringedContentTypes = DOCUMENT_CONTENT_TYPE_VALUES.map(String);

export default {
    name: 'InputDocumentType',
    components: {
        InputCheckbox,
    },
    props: {
        modelValue: {
            type: Array,
            required: true,
        },
        name: {
            type: String,
            default: 'document-type',
        },
        totals: {
            type: Object,
            default: () => ({}),
            validator: (obj) => Object.keys(obj).every((key) => stringedContentTypes.includes(key)),
        },
        /** adds "All Documents" input */
        withAll: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['input', 'update:modelValue'],

    computed: {
        /** this prop makes sure we don't have '0' in the modelValue array (for backwards compatibility with older search urls) */
        sanitizedValue() {
            return removeFromArray('0', this.modelValue);
        },
        hasTotals() {
            return Object.keys(this.totals).length > 0;
        },
        totalsDefault() {
            return this.hasTotals ? 0 : null;
        },
        types() {
            const filters = stringedContentTypes.map((id) => ({
                id,
                name: this.$t(`common:documentTypes.${id}`),
                total: this.totals[id] !== undefined ? this.totals[id] : this.totalsDefault,
            }));

            if (this.withAll) {
                filters.unshift({
                    id: '0',
                    name: this.$t('common:documentTypes.0'),
                    total: filters.reduce(
                        (total, filter) => (filter.total ? total + filter.total : total),
                        this.totalsDefault,
                    ),
                });
            }

            return filters;
        },
    },

    methods: {
        onChange(arr) {
            const val = !arr || !arr.length || arr.indexOf('0') > 0 ? [] : removeFromArray('0', arr);

            this.$emit('input', val);
            this.$emit('update:modelValue', val);
        },
        onClick(event, type) {
            if (type.id === '0' && !this.sanitizedValue.length) {
                // prevent unselecting "All Documents" if selected
                event.preventDefault();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.input {
    min-width: 14rem;
}
</style>
